import React from 'react';
import { Link } from 'react-router-dom';
import { FlameMark, SOCIAL_ICONS } from './icons';
import { CONTACT_EMAIL, SOCIAL_LINKS, STEAM_URL, STUDIO_NAME, TAGLINE } from '../site-config.mjs';
import { trackWishlistClick } from '../analytics';
import './site-footer.css';

export default function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="shell site-footer__inner">
        <div className="site-footer__brand">
          <div className="site-footer__mark">
            <FlameMark size={26} />
            <span>Warm</span>
          </div>
          <p className="site-footer__tagline">{TAGLINE}</p>
          <p className="site-footer__studio">
            A game by
            {' '}
            {STUDIO_NAME}
          </p>
        </div>

        <nav className="site-footer__columns" aria-label="Footer">
          <div className="site-footer__column">
            <h2>Game</h2>
            <a
              href={STEAM_URL}
              target="_blank"
              rel="noreferrer"
              onClick={() => trackWishlistClick('footer')}
            >
              Steam page
            </a>
            <Link to="/#the-game">Features</Link>
            <Link to="/#trailer">Trailer</Link>
            <Link to="/#screens">Screenshots</Link>
          </div>

          <div className="site-footer__column">
            <h2>Support</h2>
            <Link to="/feedback">Send feedback</Link>
            <Link to="/#faq">FAQ</Link>
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </div>

          <div className="site-footer__column">
            <h2>Legal</h2>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms and Conditions</Link>
            <Link to="/eula">EULA</Link>
          </div>
        </nav>
      </div>

      <div className="shell site-footer__base">
        <p>
          &copy;
          {' '}
          {new Date().getFullYear()}
          {' '}
          {STUDIO_NAME}
          . All rights reserved.
        </p>
        <ul className="site-footer__social">
          {SOCIAL_LINKS.map(({ label, url }) => {
            const Icon = SOCIAL_ICONS[label];
            return (
              <li key={label}>
                <a href={url} target="_blank" rel="noreferrer" aria-label={label}>
                  {Icon ? <Icon /> : label}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </footer>
  );
}
